import './about.css'
import { motion } from 'framer-motion'

const reveal = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
}

export default function AboutLeft({ Title, Subtitle, children, Image }) {
  return (
    <motion.section
      className="about"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.25 }}
      variants={reveal}
    >
      <div className="about-container about-layout">
        <motion.div className="about-text" variants={reveal}>
          <h2>{Title}</h2>
          <h3>{Subtitle}</h3>
          {children}
        </motion.div>

        {Image && (
          <motion.div className="about-image about-image-team" variants={reveal}>
            <div className="image-frame image-frame-team">
              <img src={Image} alt="Image groupe Provence Compta" />
            </div>
          </motion.div>
        )}
      </div>
    </motion.section>
  )
}